import script from "./ClubHighlightExtEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightExtEdit.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightExtEdit.vue?vue&type=style&index=0&id=d65e65a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65e65a4"]])

export default __exports__